import { Box, HStack, Progress, Text, VStack } from 'native-base';
import React, { useContext, useEffect, useMemo, useState } from 'react';
import Functions from '../../../utils/Functions';
import { InputNumber } from '../../InputNumber';
import { CustomSlider } from '../../Slider';
import Footer from '../Footer';
import { NavigationContext } from '../../../contexts';
const WithdrawalAmount = /*#__PURE__*/React.memo(_ref => {
  let {
    metadata: {
      equityCash,
      isPersonalizedCashOut
    },
    valueKey,
    navigation,
    title,
    id,
    navigation: {
      current
    }
  } = _ref;
  const FOOTER_NOTES = `Disclaimer: The estimated cash-out amount was calculated by subtracting the outstanding principal balance of your loan from [80% if conventional or FHA and 90% if VA] of your property’s estimated value and assumes closing costs will be paid in cash. Your actual cash-out amount may be less. It will be calculated by taking [80% for conventional and FHA and 90% for VA] of your property’s actual value (as determined by a full appraisal) and subtracting all outstanding liens and any applicable costs and fees from that value.`;
  const {
    total,
    selected,
    type,
    logUserEvent,
    onSelected
  } = useContext(NavigationContext);
  useEffect(() => {
    logUserEvent({
      type,
      action: id
    });
  }, [id, logUserEvent, type]);
  const amountSelected = useMemo(() => {
    return !selected ? 0 : parseInt(selected[valueKey]);
  }, [selected, valueKey]);
  const [amount, setAmount] = useState(amountSelected);
  const [errors, setErrors] = useState({});
  const validate = value => {
    if (value <= equityCash) {
      setAmount(value);
    }
    if (value === 0) {
      setErrors({
        isEmpty: true
      });
    } else setErrors({});
  };
  const handleChange = value => {
    const amount = typeof value === 'number' ? value : Number(value.replace(/\D/g, ''));
    validate(amount);
  };
  return /*#__PURE__*/React.createElement(Box, {
    key: id
  }, /*#__PURE__*/React.createElement(Text, {
    fontSize: "4xl",
    fontWeight: 'light',
    accessibilityLabel: title,
    accessibilityRole: "text",
    testID: `radio-card-group-${title}`,
    mb: "5"
  }, title), /*#__PURE__*/React.createElement(VStack, {
    space: 1,
    w: "99%"
  }, /*#__PURE__*/React.createElement(Progress, {
    value: Math.ceil(100 / total * current),
    h: "2",
    bg: "white.700",
    borderColor: "#979797",
    borderWidth: "0.25",
    _filledTrack: {
      bg: {
        linearGradient: {
          colors: ['#8C98A3', '#1B68A5'],
          start: [0, 0],
          end: [1, 0]
        }
      }
    }
  }), /*#__PURE__*/React.createElement(Text, {
    textAlign: "right",
    fontFamily: "body",
    fontWeight: "medium",
    fontSize: "sm",
    color: "navyblue.500"
  }, `${current}/${total}`)), /*#__PURE__*/React.createElement(VStack, {
    space: {
      base: 7,
      md: 12
    },
    alignItems: "center",
    mx: 7
  }, /*#__PURE__*/React.createElement(Text, {
    fontSize: 'md',
    color: "text.running"
  }, "You can either move the slider or type into the field below to adjust your approximate budget amount."), /*#__PURE__*/React.createElement(HStack, {
    space: {
      sm: 12
    },
    flexWrap: "wrap"
  }, /*#__PURE__*/React.createElement(VStack, {
    space: 2,
    mb: {
      base: 7,
      sm: 0
    }
  }, /*#__PURE__*/React.createElement(InputNumber, {
    label: "Cash Amount",
    value: amount,
    errors: errors,
    handleChange: handleChange
  })), /*#__PURE__*/React.createElement(VStack, {
    space: 2
  }, /*#__PURE__*/React.createElement(Text, {
    fontSize: 'md',
    color: 'black.200',
    fontWeight: 500
  }, "Cash Amount"), /*#__PURE__*/React.createElement(Text, {
    fontSize: "32",
    fontWeight: 500
  }, !amount ? '$0' : `${Functions.toLocalString(amount)}`))), /*#__PURE__*/React.createElement(CustomSlider, {
    value: amount,
    maxLimit: equityCash,
    handleChange: handleChange
  })), isPersonalizedCashOut ? /*#__PURE__*/React.createElement(Text, {
    fontSize: "xs",
    mt: "66"
  }, FOOTER_NOTES) : null, /*#__PURE__*/React.createElement(Footer, {
    onNext: onSelected,
    navigation: navigation,
    selectedValue: amount,
    valueKey: valueKey,
    onNextEvent: `${type}WithdrawalNextClicked`,
    onBackEvent: `${type}WithdrawalBackClicked`
  }));
});
export default /*#__PURE__*/React.memo(WithdrawalAmount);
//# sourceMappingURL=index.js.map